import React from 'react';
import {UploadDataPoint} from "../_section/DataPointForm";


function DataForm({upload, inExtWindow, setMortgage}) {
    return (
        <>
            <UploadDataPoint setMortgage={setMortgage} name="year" upload={upload} inExtWindow={inExtWindow}/>


            <div className="w-100" style={{borderBottom: '1px solid #a3a3a3'}}/>


            <div className="d-row j-equal gap-9">
                <UploadDataPoint setMortgage={setMortgage} name="employer1" upload={upload} inExtWindow={inExtWindow}/>
                <UploadDataPoint setMortgage={setMortgage} name="start1" upload={upload} inExtWindow={inExtWindow}/>
            </div>
            <div className="d-row j-equal gap-9">
                <UploadDataPoint setMortgage={setMortgage} name="pay1" upload={upload} inExtWindow={inExtWindow}/>
                <UploadDataPoint setMortgage={setMortgage} name="end1" upload={upload} inExtWindow={inExtWindow}/>
            </div>

            
            <div className="w-100" style={{borderBottom: '1px solid #a3a3a3'}}/>


            <div className="d-row j-equal gap-9">
                <UploadDataPoint setMortgage={setMortgage} name="employer2" upload={upload} inExtWindow={inExtWindow}/>
                <UploadDataPoint setMortgage={setMortgage} name="start2" upload={upload} inExtWindow={inExtWindow}/>
            </div>
            <div className="d-row j-equal gap-9">
                <UploadDataPoint setMortgage={setMortgage} name="pay2" upload={upload} inExtWindow={inExtWindow}/>
                <UploadDataPoint setMortgage={setMortgage} name="end2" upload={upload} inExtWindow={inExtWindow}/>
            </div>


            <div className="w-100" style={{borderBottom: '1px solid #a3a3a3'}}/>


            <div className="d-row j-equal gap-9">
                <UploadDataPoint setMortgage={setMortgage} name="employer3" upload={upload} inExtWindow={inExtWindow}/>
                <UploadDataPoint setMortgage={setMortgage} name="start3" upload={upload} inExtWindow={inExtWindow}/>
            </div>
            <div className="d-row j-equal gap-9">
                <UploadDataPoint setMortgage={setMortgage} name="pay3" upload={upload} inExtWindow={inExtWindow}/>
                <UploadDataPoint setMortgage={setMortgage} name="end3" upload={upload} inExtWindow={inExtWindow}/>

            </div>


        </>
    );


}


export default DataForm;